export default function getInitState() {
    return {
        logDataTableOptions: {
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        logActions: [
            {
                btn_text: '<i class="fas fa-cloud-download-alt"></i> Betöltés indítása',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'loadPuphaX'
            }
        ],
        logRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showDetails'
            }
        ],
        logHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
            },
            {
                name: "starter",
                label: "Indító",
                sort: false,
                visibility: true,
            },
            {
                name: "result",
                label: "Státusz",
                sort: false,
                visibility: true
            },
            {
                name: "startTime",
                label: "Indítás időpontja",
                sort: true,
                visibility: true,
                slot_name: "datetime_format"
            },
            {
                name: "endTime",
                label: "Vége",
                sort: false,
                visibility: true,
                slot_name: "appointment_format"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        detailsDataTableOptions: {
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        detailsHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
            },
            {
                name: "message",
                label: "Bejegyzés",
                sort: false,
                visibility: true,
            },
            {
                name: "createdOn",
                label: "Időpont",
                sort: true,
                visibility: true,
                slot_name: "datetime_format"
            }
        ]
    }
}
